<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>Добавление нового столбца</template>
        <template v-slot:content>
            <v-form v-model = 'validField' class = 'py-2 px-4'>
                <v-text-field
				    label = 'Название поля'
				    v-model = 'schemaField.name'
				    hint = 'Введите название поля на латинице без специальных символов'
				    :rules = "[rules.required,rules.safe]"
				    clearable
				    counter='20'
				></v-text-field>
				<v-select
	                :items = 'fields'
				    multiple
		            chips
		            label = 'Столбцы'
		            hint = 'Выберите столбцы для расчета параметра'
			        v-model = 'schemaField.fields'
		            :rules = "[rules.required]"
				></v-select>
				<v-select
				    :items = '[{"text": "Суммирование", "value": "summarize"}]'
		            label = 'Агрегация'
				    v-model = 'schemaField.aggregation'
		            :rules = "[rules.required]"
				></v-select>
            </v-form>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 light-blue--text text--darken-2' :loading = 'indicator' block depressed @click = 'addSchemaField'>Добавить</v-btn>
        </template>
    </dialog-generic>
</template>

<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'CreateSchemaField',
        props: ['visibility', 'fields'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visible: this.visibility,
                validField: false,
                schemaField: {
                    type: 'metric'
                },
                indicator: false,
                action: false,
                rules: {
	                required: value => !!value || 'Обязательное поле.',
	                email: value => {
	                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	                    return pattern.test(value) || 'Неправильный e-mail.'
	                },
	                safe: value => {
	                    const pattern = /^[a-zA-Z0-9_]*$/
	                    return pattern.test(value) || 'Неверный формат'
	                }
	            }
            }
        },
        methods: {
            addSchemaField() {
                this.indicator = true;
                let project = this.$store.state.currentProject
				let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8',
		          'Authorization': 'Bearer ' + this.$store.getters.userToken
		        }
		        this.schemaField.fields = this.schemaField.fields.join(',')
		        this.$http.post(this.$store.getters.endpoint + '/db/project/' + project.project_id + '/schema', {
				        'login': this.$store.getters.userLogin,
				        'regularity': 'custom',
				        'project_table': project.project_table,
				        ...this.schemaField
				    } , {
				        headers: {...this.$store.state.restrictedHeaders,...requestHeaders
				    }
			    }).then( (r) => {
					this.indicator = false
					this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'create',
                            target: 'project_schemafield'
                        },
                        once: false
                    })
                    this.action = true
                    this.visible = false
			    });
			},
        },
        watch: {
            visibility(value) {
                this.visible = value
            },
            visible(value) {
                if (!value) {
                    this.$root.$emit('CRUDSchemaVisibility', {visibility: value, update: this.action, type: 'create'})
                }
            }
        }
    }
</script>